class FloorElement {
  store;
  id;

  label;
  labelRotated;

  srf;
  srfRotated;

  position;
  locationId;
  type;

  constructor(store, id, label, labelRotated, srf, srfRotated, locationId, type) {
    this.store = store;
    this.id = id;

    this.label = label;
    this.labelRotated = labelRotated;
    this.srf = srf;
    this.srfRotated = srfRotated;
    this.locationId = locationId;
    this.type = type;
  }

  setPositionForView(width, height, angle, offset = {x: 0, y: 0}){
        angle = (angle + 360) % 360;
        var xy = this.srf;

        if((angle + 360) % 180 !== 0 && this.srfRotated && !['FEATURE', 'HEREMARK', 'COMPASS'].indexOf(this.type) > -1){
          xy = this.srfRotated;
        }

        if(angle === 180){
          angle = 0;
        }else if(angle === 270){
          angle = 90;
        }

        var o;
        if(angle === 0){
             o =  xy;
        }else if(angle ===  180){
             o =  {x : width - xy.x, y : height - xy.y};
        }else if(angle ===  90){
             o =  {x : height - xy.y, y : xy.x};
        }else if(angle === 270){
             o =  {x : xy.y, y : width - xy.x};
        }else {
            throw new Error(`Unsupported orientation: ${angle}`);
        }
        this.position =  {x : o.x + offset.x, y : o.y + offset.y, x_ : width - o.x, y_ : height - o.y };
  }

  static fromJSON(store, json) {
    let { id, label, labelRotated, srf, srfRotated, locationId, type } = json;
    return new FloorElement(store, id, label, labelRotated, srf, srfRotated, locationId, type);
  }
}

export default FloorElement;
